var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customer-service"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPanel,
      expression: "showPanel"
    }],
    staticClass: "cs-panel"
  }, [_c('div', {
    staticClass: "cs-header"
  }, [_c('span', [_vm._v("在线客服")]), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function ($event) {
        _vm.showPanel = false;
      }
    }
  })]), _c('div', {
    staticClass: "cs-content"
  }, [_vm.inited ? _c('CustomerServiceChat', {
    style: {
      width: '100%',
      height: '100%'
    }
  }) : _vm._e()], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPanel,
      expression: "showPanel"
    }],
    staticClass: "cs-mask",
    on: {
      "click": function ($event) {
        _vm.showPanel = false;
      }
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }